import { post } from '@/services/http';

export interface ShopifyAccessTokenReveal {
  storeId: number;
  shopName: string;
  accessToken: string;
  expiresAt: string | null;
  retrievedAt: string;
  tokenType: 'expiring' | 'non-expiring';
}

function isValidTimestamp(value: unknown): value is string {
  return typeof value === 'string' && value.length > 0 && Number.isFinite(new Date(value).getTime());
}

export function normalizeShopifyAccessTokenReveal(data: any): ShopifyAccessTokenReveal {
  const tokenType = data && data.token_type;
  const expiresAt = data && data.expires_at;
  const validTokenType = tokenType === 'expiring' || tokenType === 'non-expiring';
  const validExpiry = tokenType === 'expiring'
    ? isValidTimestamp(expiresAt)
    : expiresAt === null || isValidTimestamp(expiresAt);

  if (
    !data ||
    !Number.isInteger(data.store_id) ||
    data.store_id <= 0 ||
    typeof data.shop_name !== 'string' ||
    data.shop_name.length === 0 ||
    typeof data.access_token !== 'string' ||
    data.access_token.length === 0 ||
    !isValidTimestamp(data.retrieved_at) ||
    !validTokenType ||
    !validExpiry
  ) {
    throw new Error('Invalid Shopify access token response');
  }

  return {
    storeId: data.store_id,
    shopName: data.shop_name,
    accessToken: data.access_token,
    expiresAt,
    retrievedAt: data.retrieved_at,
    tokenType,
  };
}

export async function revealShopifyAccessToken(storeId: number): Promise<ShopifyAccessTokenReveal> {
  const response: any = await post(`/stores/${storeId}/shopify-access-token/reveal`, {});
  const data = response.data || response;
  return normalizeShopifyAccessTokenReveal(data);
}

export async function auditShopifyAccessTokenCopy(storeId: number, retrievedAt: string): Promise<void> {
  await post(`/stores/${storeId}/shopify-access-token/copy-audit`, {
    retrieved_at: retrievedAt,
  });
}

